import { render } from "./InprocessApplicationList.vue?vue&type=template&id=566e96da&scoped=true"
import script from "./InprocessApplicationList.vue?vue&type=script&lang=js"
export * from "./InprocessApplicationList.vue?vue&type=script&lang=js"

import "./InprocessApplicationList.vue?vue&type=style&index=0&id=566e96da&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\know_your_doctor\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-566e96da"]])

export default __exports__